import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/opt/lumi/src/lumi/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/lumi/src/lumi/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lumi/src/lumi/src/components/ClientErrorReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lumi/src/lumi/src/components/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/lumi/src/lumi/src/components/ui/toaster.tsx");
